import styled, { createGlobalStyle } from "styled-components";

export const Colors = {
  primary: "#575151",
  error: '#d23c3c'
};

const GlobalStyle = createGlobalStyle`
*{
   box-sizing: border-box;
    
  }

    ul{
      margin:0 !important;      
      padding:0 !important;
    }

    body{     
      margin: 0 auto;
      font-size: 10pt;      
      font-family: "Roboto";
    }

    table {  
  border: 1px solid black;  
  width: 100%;
  border-collapse: collapse;
}

th{
  background-color: ${Colors.primary};
  border: 1px solid black;
  color: white;
}

tr {
  border: 1px solid green;
  
  padding: 8px;
}

tr:nth-child(even){background-color: #f2f2f2}

td {
  border: 1px solid black;
  padding: 8px;
}


tr td:last-child {
  width: 1%;
  white-space: nowrap;
}

tr td:first-child {
  width: 1%;
  white-space: nowrap;
}

`;

export default GlobalStyle;
